import * as React from "react"

const RewardPointSvg = (props) => (
  <svg
    width={15}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M8.857 10.46a.146.146 0 0 1 .197.059l4.062 7.57a.144.144 0 0 1-.01.154.146.146 0 0 1-.144.058l-2.662-.474-.465 2.107a.146.146 0 0 1-.271.037l-4.061-7.57a.145.145 0 0 1 .06-.196l3.294-1.746Z"
        fill="#5067D0"
        stroke="#5067D0"
        strokeLinejoin="round"
      />
      <path
        d="M4.628 10.46a.146.146 0 0 0-.197.059l-4.062 7.57a.144.144 0 0 0 .011.154.146.146 0 0 0 .144.058l2.661-.474.465 2.107a.146.146 0 0 0 .271.037l4.062-7.57a.145.145 0 0 0-.06-.196l-3.295-1.746Z"
        fill="#5067D0"
        stroke="#5067D0"
        strokeLinejoin="round"
      />
      <path
        d="M7.031 14.413c3.866 0 7-3.114 7-6.956 0-3.842-3.134-6.957-7-6.957s-7 3.115-7 6.957c0 3.842 3.134 6.956 7 6.956Z"
        fill="#F93D92"
      />
      <path
        d="M7.031 13.022c3.093 0 5.6-2.492 5.6-5.565 0-3.074-2.507-5.566-5.6-5.566-3.093 0-5.6 2.492-5.6 5.566 0 3.073 2.507 5.565 5.6 5.565Z"
        fill="#FF8DB7"
      />
      <path
        d="M7.308 5.048a.292.292 0 0 0-.554 0L6.295 6.45H4.812a.289.289 0 0 0-.171.524l1.2.867-.459 1.402c-.039.12.004.25.106.324.102.074.24.074.343 0l1.2-.867 1.2.867c.102.074.24.074.343 0a.289.289 0 0 0 .106-.324L8.222 7.84l1.2-.867a.289.289 0 0 0-.172-.524H7.767l-.459-1.402Z"
        fill="#F5C400"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.031 .5)" d="M0 0h14v20H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default RewardPointSvg
